<div class="lum-rfq-scan-mode-input flex">
  <button type="button" [disabled]="disabled" class="lum-button scan-mode-button">
    Scan Mode
  </button>
  <input
    type="text"
    class="lum-input scan-mode-input"
    placeholder="Scan here..."
    [formControl]="scanSearchStr"
    [matAutocomplete]="auto"
    [readonly]="disabled"
    [disabled]="disabled"
    (input)="onSearchRfqs($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFnRfq"
    [panelWidth]="500"
    (optionSelected)="onSelectSku($event)"
    class="rfq-item-autocomplete"
  >
    <ng-container *ngIf="!loading; else loader">
      <mat-option
        *ngFor="let rfq of rfqs; trackBy: trackById"
        [value]="rfq"
        class="rfq-item-option"
      >
        <div class="rfq-item flex gap-4 w-100">
          <div class="flex align-items-center">
            <img [lumRfqThumbnailUrl]="rfq" alt="" class="lum-img lum-thumbnail" />
          </div>
          <div>
            <div> {{ rfq?.product_name }} [{{ rfq?.sku ? rfq?.sku : 'N/A' }}] </div>
            <small>
              {{ rfq?.product_name }}
            </small>
          </div>
        </div>
      </mat-option>
    </ng-container>
    <ng-template #loader>
      <mat-option>
        <div class="flex gap-4">
          <mat-progress-spinner
            class="progress-spinner mt-3"
            diameter="24"
            mode="indeterminate"
          ></mat-progress-spinner>
          <small>Loading...</small>
        </div>
      </mat-option>
    </ng-template>
  </mat-autocomplete>
</div>
